module.exports = __webpack_public_path__ + "static/banishment_mtg_clb-7459d3722410d28872033b0c98f466a3.webp";